import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { search } from '../../assets/svg/dashboard/main'


export const Input = ({onChange, ...props}) => {
  
  const [searchString, setSearchString] = useState('')
  const [firstRender, setFirstRender] = useState(true)

  useEffect(() => {
    if (!searchString && firstRender) return;
    firstRender && setFirstRender(false)
    const timeout = setTimeout(() => {
      onChange(searchString)
    }, 1000);
    return () => {
      clearTimeout(timeout)
    }
  }, [searchString])
  
  
  return (
    <div className={styles.input}>
      <input value={searchString} onChange={e => setSearchString(e.target.value)} {...props}/>
      {search}
    </div>
  )
}
